import React from "react";
import { BlockedItemsInterface } from "./hooks/useBlockedItemsProvider";
import { BlockedItem } from "@pepdirect/shared/types";

export const BlockedItemsContext = React.createContext<BlockedItemsInterface>({
  blockedItems: [],
  setBlockedItems: (_items: BlockedItem[]) => {},
});
